
import imageCompression from 'browser-image-compression';
export const compressImage = async (file, size = 5) => {
    const TARGET_SIZE_BYTES = size * 1024 * 1024;
    if (file.size <= TARGET_SIZE_BYTES) return file;

    const options = {
        maxSizeMB: size, // Compress to approx size limit
        maxWidthOrHeight: 1920,
        useWebWorker: true,
    };

    try {
        const compressedFile = await imageCompression(file, options);
        if (compressedFile.size > TARGET_SIZE_BYTES) {
            throw new Error(`File is too large to compress under ${size}MB (Best: ${(compressedFile.size / (1024 * 1024)).toFixed(2)}MB). Please use a smaller file.`);
        }
        return compressedFile;
    } catch (error) {
        console.error("Compression failed:", error);
        let errorMessage = error instanceof Error ? error.message : String(error);

        if (errorMessage === '[object Event]' || errorMessage.includes('Event')) {
            errorMessage = `File is too large to compress under ${size}MB (Best: ${(file.size / (1024 * 1024)).toFixed(2)}MB). Please use a smaller file.`;
        }

        throw new Error(errorMessage);
    }
};